/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HeroBannerSettingsImageWidth = "full" | "half" | "%future added value";
export type HpRespHeroBannerText_heroBannerSettings = {
    readonly textAlignment: string | null;
    readonly contentColor: string | null;
    readonly eyeBrowText: string | null;
    readonly headerText: string | null;
    readonly dekText: string | null;
    readonly ctaStyle: string | null;
    readonly bannerImageWidth: HeroBannerSettingsImageWidth | null;
    readonly " $refType": "HpRespHeroBannerText_heroBannerSettings";
};
export type HpRespHeroBannerText_heroBannerSettings$data = HpRespHeroBannerText_heroBannerSettings;
export type HpRespHeroBannerText_heroBannerSettings$key = {
    readonly " $data"?: HpRespHeroBannerText_heroBannerSettings$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespHeroBannerText_heroBannerSettings">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespHeroBannerText_heroBannerSettings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textAlignment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eyeBrowText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headerText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dekText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaStyle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bannerImageWidth",
      "storageKey": null
    }
  ],
  "type": "HeroBannerSettingsType",
  "abstractKey": null
};
(node as any).hash = '867c39f3bd61b3c966df2a36cf1692fd';
export default node;
